import React from 'react';
import clsx from 'clsx';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import SearchIcon from '@material-ui/icons/Search';
import EditIcon from '@material-ui/icons/Edit';
import ListAlt from '@material-ui/icons/ListAlt';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import ActionBar from '../ActionBar';
import Button from '../controls/Button';
import Panel from '../controls/Panel';
import getNewEntry from './Entries';
import FieldDialog from './FieldDialog';
import SearchPropertiesDialog from './FieldDialog/RepeatableFieldSearch/SearchPropertiesDialog';
import FieldsPanel from './FieldsPanel';
import UnsavedDialog from './../UnsavedDialog';
import ToggleButton from '../controls/SmallButton';
import StepperPanel from '../StepperPanel/StepperPanel';
import {
    updateVisibilityAndValidationOnDelete,
    updateVisibilityAndValidationOnNameChange,
    checkFieldNameUsedInRules,
    stepForwardActiveSection,
    stepBackActiveSection,
} from './formBuilderLogic';
import DeleteDialog from './DeleteDialog';
import DraggableFormDisplay from './DraggableFormDisplay';
import ImportFormDialog from './ImportFormDialog';
import DataEditor from '../controls/DataEditor';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ViewToggleButton from '@material-ui/lab/ToggleButton';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import CodeIcon from '@material-ui/icons/Code';
import { Alert, AlertTitle } from '@material-ui/lab';
import { withAuthenticationContext } from '../Authenticate';
import { compose } from 'redux';
import { featuresList } from '../constants';

const drawerWidth = 280;

const styles = (theme) => ({
    root: {
        [theme.breakpoints.up('lg')]: {
            paddingLeft: '15%',
            paddingRight: '15%',
        },
    },
    contentSpacer: {
        ...theme.mixins.toolbar,
        marginTop: theme.spacing(3),
    },
    actionBar: {
        marginTop: theme.spacing(6),
        display: 'flex',
    },
    drawerSpacer: theme.mixins.toolbar,

    leftCollapseButton: {
        left: drawerWidth - 15,
        transition: theme.transitions.create('left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    leftExpandButton: {
        left: theme.spacing(7),
        transition: theme.transitions.create('left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.up('sm')]: {
            left: theme.spacing(7) + 1,
        },
    },
    leftDrawerContainer: {
        whiteSpace: 'normal',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    leftDrawerContainerCollapsed: {
        paddingLeft: theme.spacing(2),
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
    },
    grow: {
        flexGrow: 1,
    },
    text: {
        textAlign: 'center',
        marginTop: theme.spacing(7),
    },
    bigArrow: {
        paddingTop: theme.spacing(4),
        fontSize: 70,
    },
    rightCollapseButton: {
        right: drawerWidth - 15,
        transition: theme.transitions.create('right', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    rightExpandButton: {
        right: theme.spacing(7),
        transition: theme.transitions.create('right', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.up('sm')]: {
            right: theme.spacing(7) + 1,
        },
    },
    panelButton: {
        position: 'fixed',
        top: theme.mixins.toolbar.minHeight * 2,
        '@media (min-width:0px) and (orientation: landscape)': {
            top: theme.mixins.toolbar['@media (min-width:0px) and (orientation: landscape)'].minHeight * 2,
        },
        '@media (min-width:600px)': {
            top: theme.mixins.toolbar['@media (min-width:600px)'].minHeight * 2,
        },
        marginTop: theme.spacing(4),
        zIndex: theme.zIndex.appBar,
    },
    drawerOpen: {
        width: drawerWidth,
        zIndex: theme.zIndex.appBar - 1,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        zIndex: theme.zIndex.appBar - 1,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),

        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(7) + 1,
        },
        padding: theme.spacing(1),
    },
    drawer: {
        flexShrink: 0,
        whiteSpace: 'nowrap',
        overflowX: 'hidden',
    },
    multipleFieldLeftPanel: {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark,
    },
    sidebarDiv: {
        paddingTop: theme.spacing(4.5),
        paddingBottom: theme.spacing(2),
    },
    sectionTitle: {
        overflowWrap: 'normal',
    },
    multipleFieldPath: {
        overflowWrap: 'break-word',
        paddingTop: theme.spacing(1),
    },
    listItem: {
        borderRadius: 4,
        marginTop: theme.spacing(5),
        height: 40,
        '&:hover': {
            backgroundColor: '#003453',
            cursor: 'pointer',
        },
    },
    listItemIcon: {
        minWidth: 20,
        minHeight: 20,
        marginRight: 8,
    },
    iconColor: {
        color: '#fff',
    },
    selectedTab: {
        '&.Mui-selected': {
            backgroundColor: '#003453',
        },
        '&.Mui-selected:hover': {
            backgroundColor: '#003453',
        },
    },
    accordionDetails: {
        padding: 0,
    },
    listItemTextAccordion: {
        color: 'white',
        paddingLeft: theme.spacing(4),
        '&:hover': {
            backgroundColor: '#003453',
            cursor: 'pointer',
        },
    },
    listItemAccordion: {
        marginTop: theme.spacing(0.5),
        borderRadius: 4,
        height: 40,
        '&:hover': {
            backgroundColor: '#003453',
        },
    },
    searchPropertiesTab: {
        borderRadius: 4,
        marginTop: theme.spacing(1),
    },
    toggleButtonGroup: {
        marginBottom: theme.spacing(0.5),
    },
    view: {
        padding: theme.spacing(1),
    }
});

class FormBuilder extends React.Component {
    state = {
        isRepeatableTabExpanded: false,
        currentField: {},
        currentMultipleField: {},
        sectionDialogOpen: false,
        multipleSubFields: [],
        searchFields: [],
        rightPanelOpen: true,
        leftPanelOpen: true,
        sectionName: '',
        multipleFieldLabel: '',
        openFieldDialog: false,
        openUnsavedDialog: false,
        selectedRepeatableTab: 'repeatableField',
        openSearchPropertiesDialog: false,
        searchForm: {},
        deleteField: { deleteDialogOpen: false, referenceIndexes: [] },
        importFormDialogOpen: false,
        currentView: 'form',
        jsonEditorError: false,
    };

    handleLeftDrawerToggle = () => {
        this.setState((prevState) => ({
            leftPanelOpen: !prevState.leftPanelOpen,
        }));
    };

    handleRemoveSection = (index) => {
        this.props.onSectionsChange('delete', index);
    };

    handleRightDrawerToggle = () => {
        this.setState((prevState) => ({
            rightPanelOpen: !prevState.rightPanelOpen,
        }));
    };

    componentDidMount() {
        this.unblock = this.props.history.block(() => {
            if (this.props.unsavedChanges) {
                this.props.onStepChange(-1);
                this.setState({
                    openUnsavedDialog: true,
                });
                return false;
            } else {
                this.handleCloseUnsavedDialog();
                return true;
            }
        });
        if (this.props.match.params.id) {
            this.props.onLoad(this.props.match.params.id);
        }
    }

    componentDidUpdate(prevProps) {
        const newSection = this.props.form.sections[this.props.currentSection];
        const newSectionName = newSection ? newSection.name : '';
        if (
            this.props.currentSection !== prevProps.currentSection ||
            (newSectionName !== this.state.sectionName && !this.state.sectionDialogOpen)
        ) {
            this.setState({
                sectionName:
                    this.props.currentSection === -1 ? '' : this.props.form.sections[this.props.currentSection].name,
            });
        }
    }

    isEditingNestedFields = () => {
        return this.props.multipleFieldIndex >= 0;
    };

    isEditingNestedSearchFields = () => {
        return this.props.multipleFieldIndex >= 0 && this.state.selectedRepeatableTab === 'searchFields';
    };

    handleCloseUnsavedDialog = () => {
        this.setState({
            openUnsavedDialog: false,
        });
    };

    componentWillUnmount() {
        this.unblock();
        this.props.onUnload();
    }

    handleStepChange = (step) => {
        this.props.onStepChange(step);
    };

    handleSectionsReorder = (sections) => {
        this.props.onSectionsReorder(sections);
    };

    handleContinue = () => {
        const activeSection = stepForwardActiveSection(this.props.form.sections, this.props.currentSection);
        this.props.onStepChange(activeSection);
    };

    handleBack = () => {
        const activeSection = stepBackActiveSection(this.props.form.sections, this.props.currentSection);
        this.props.onStepChange(activeSection);
    };

    handleAddSection = () => {
        this.props.onSectionsChange('add');
    };

    handleSectionDialogOpen = () => {
        this.setState({ sectionDialogOpen: true });
    };

    handleSectionDialogClose = (event) => {
        this.setState({ sectionDialogOpen: false });
        event.preventDefault();
    };

    handleChangeSection = (event) => {
        this.setState({
            sectionName: event.target.value,
        });
    };

    handleAddField = (typeId) => {
        let newEntry = getNewEntry(
            typeId,
            this.props.currentSection + 1,
            this.props.form.sections[this.props.currentSection].entries.length + 1,
        );
        if (this.isEditingNestedSearchFields()) {
            newEntry = {
                ...newEntry,
                field: `SearchField${this.state.searchFields.length + 1}`,
            };
            this.setState({
                currentMultipleField: newEntry,
                searchFields: [...this.state.searchFields, newEntry],
            });
        } else if (this.isEditingNestedFields()) {
            newEntry = {
                ...newEntry,
                field: `Repeatable Field ${this.state.multipleSubFields.length + 1}`,
            };
            this.setState({
                currentMultipleField: newEntry,
                multipleSubFields: [...this.state.multipleSubFields, newEntry],
            });
        } else {
            this.props.onEntriesChange(newEntry, this.props.form.sections[this.props.currentSection].entries.length);
            this.setState((prevState) => ({
                currentField: newEntry,
                searchForm: {
                    ...prevState.searchForm,
                    addRecordText: newEntry?.searchForm?.addRecordText,
                    url: newEntry?.searchForm?.api?.url,
                    resultMappings: newEntry?.searchForm?.api?.resultMappings,
                },
            }));
        }
    };

    handleDeleteDialog = (modifiedEntry) => {
        let fieldReferenceInRules = { fieldReferenced: false, referenceIndexes: [] };
        if (this.isEditingNestedSearchFields()) {
            let updatedSearchFields = this.state.searchFields.filter((entry) => entry !== modifiedEntry);
            fieldReferenceInRules = checkFieldNameUsedInRules(updatedSearchFields, modifiedEntry.field);
        } else if (this.isEditingNestedFields()) {
            let updatedSubFields = this.state.multipleSubFields.filter((entry) => entry !== modifiedEntry);

            fieldReferenceInRules = checkFieldNameUsedInRules(updatedSubFields, modifiedEntry.field);
        } else {
            this.props.form.sections.forEach((section) => {
                if (section.entries) {
                    let updatedEntries = section.entries.filter((entry) => entry !== modifiedEntry);
                    const { fieldReferenced, referenceIndexes } = checkFieldNameUsedInRules(
                        updatedEntries,
                        modifiedEntry.field,
                    );
                    fieldReferenceInRules.fieldReferenced = fieldReferenced || fieldReferenceInRules.fieldReferenced;
                    fieldReferenceInRules.referenceIndexes.push(referenceIndexes);
                }
            });
        }
        if (fieldReferenceInRules.fieldReferenced) {
            this.setState({
                deleteField: {
                    deleteDialogOpen: true,
                    referenceIndexes: fieldReferenceInRules.referenceIndexes,
                },
                currentField: modifiedEntry,
            });
        } else {
            this.handleDeleteField(modifiedEntry);
        }
    };

    handleDeleteDialogClose = () => {
        this.setState({
            deleteField: {
                deleteDialogOpen: false,
                referenceIndexes: [],
            },
            currentField: {},
        });
    };

    handleDeleteFieldFromDialog = () => {
        this.handleDeleteField(this.state.currentField);
        this.handleDeleteDialogClose();
    };

    handleDeleteField = (modifiedEntry) => {
        if (this.isEditingNestedSearchFields()) {
            let updatedSearchFields = this.state.searchFields.filter((entry) => entry !== modifiedEntry);
            this.setState({
                searchFields: updateVisibilityAndValidationOnDelete(
                    updatedSearchFields,
                    modifiedEntry.field,
                    this.state.deleteField.referenceIndexes,
                ),
            });
        } else if (this.isEditingNestedFields()) {
            let updatedSubFields = this.state.multipleSubFields.filter((entry) => entry !== modifiedEntry);
            this.setState({
                multipleSubFields: updateVisibilityAndValidationOnDelete(
                    updatedSubFields,
                    modifiedEntry.field,
                    this.state.deleteField.referenceIndexes,
                ),
            });
        } else {
            this.props.onEntriesChange(modifiedEntry, undefined, this.state.deleteField.referenceIndexes);
        }
    };

    clearSubfieldMappings = (field) => {
        return {
            ...field,
            fields: field.fields.map((subField) => ({
                ...subField,
                fieldMapping: {
                    targetPath: '',
                },
            })),
        };
    };

    handleChangeField = (field, entryIndex) => {
        if (this.isEditingNestedSearchFields()) {
            const fieldIndex = this.state.searchFields.indexOf(this.state.currentMultipleField);
            const prevFieldName = this.state.searchFields[fieldIndex].field;
            let nestedFields = [
                ...this.state.searchFields.slice(0, fieldIndex),
                field,
                ...this.state.searchFields.slice(fieldIndex + 1),
            ];
            if (this.state.currentMultipleField.field !== field.field) {
                nestedFields = updateVisibilityAndValidationOnNameChange(nestedFields, field.field, prevFieldName);
            }
            this.setState({
                currentMultipleField: field,
                searchFields: [...nestedFields],
                openFieldDialog: false,
            });
        } else if (this.isEditingNestedFields()) {
            const fieldIndex = this.state.multipleSubFields.indexOf(this.state.currentMultipleField);
            const prevFieldName = this.state.multipleSubFields[fieldIndex].field;
            let nestedFields = [
                ...this.state.multipleSubFields.slice(0, fieldIndex),
                field,
                ...this.state.multipleSubFields.slice(fieldIndex + 1),
            ];
            if (this.state.currentMultipleField.field !== field.field) {
                nestedFields = updateVisibilityAndValidationOnNameChange(nestedFields, field.field, prevFieldName);
            }
            this.setState({
                currentMultipleField: field,
                multipleSubFields: [...nestedFields],
                openFieldDialog: false,
            });
        } else {
            const prevMapping = this.state.currentField.fieldMapping;
            const fieldIndex =
                entryIndex || entryIndex === 0
                    ? entryIndex
                    : this.props.form.sections[this.props.currentSection].entries.indexOf(this.state.currentField);
            if (
                field.typeId === 'multiple' &&
                field.fieldMapping &&
                field.fieldMapping.targetPath &&
                field.fieldMapping.targetPath !== (prevMapping ? prevMapping.targetPath : null)
            ) {
                field = this.clearSubfieldMappings(field);
            }
            this.props.onEntriesChange(field, fieldIndex);
            this.setState((prevState) => ({
                currentField: field,
                searchForm: {
                    ...prevState.searchForm,
                    addRecordText: field?.searchForm?.addRecordText,
                    url: field?.searchForm?.api?.url,
                    resultMappings: field?.searchForm?.api?.resultMappings,
                },
                openFieldDialog: false,
            }));
        }
    };

    createMappingsUsed = () => {
        if (this.isEditingNestedFields()) {
            this.props.loadMappingsUsed(this.state.multipleSubFields);
        } else {
            let fields = [];
            this.props.form.sections.forEach((section) => {
                if (section.entries) {
                    fields = [...fields, ...section.entries];
                }
            });
            this.props.loadMappingsUsed(fields);
        }
    };

    handleEntrySelected = (field, index) => {
        this.createMappingsUsed();
        this.props.updateFieldIndex({ currentFieldIndex: index });
        if (this.isEditingNestedFields()) {
            this.setState({
                currentMultipleField: field,
                openFieldDialog: true,
            });
        } else {
            this.setState((prevState) => ({
                currentField: field,
                searchForm: {
                    ...prevState.searchForm,
                    addRecordText: field?.searchForm?.addRecordText,
                    url: field?.searchForm?.api?.url,
                    resultMappings: field?.searchForm?.api?.resultMappings,
                },
                openFieldDialog: true,
            }));
        }
    };

    handleCloseFieldDialog = () => {
        this.setState({
            openFieldDialog: false,
        });
        this.props.updateFieldIndex({ currentFieldIndex: -1 });
    };

    handleOpenSearchPropertiesDialog = () => {
        this.setState({
            selectedRepeatableTab: 'searchProperties',
            openSearchPropertiesDialog: true,
        });
    };

    handleCancelSearchPropertiesDialog = () => {
        this.setState({
            openSearchPropertiesDialog: false,
            selectedRepeatableTab: 'searchFields',
        });
    };

    handleDoneSearchPropertiesDialog = (addRecordText, url, resultMappings) => {
        this.setState((prevState) => ({
            openSearchPropertiesDialog: false,
            selectedRepeatableTab: 'searchFields',
            searchForm: {
                ...prevState.searchForm,
                addRecordText,
                url,
                resultMappings,
            },
        }));
    };

    handleChangeForm = (name) => {
        this.props.onNameChange(name);
    };

    handleEditMultipleField = (parentField, index) => {
        const parentMapping = parentField.fieldMapping;
        this.props.onParentMappingChange(parentMapping ? parentMapping.targetPath : '');
        this.props.updateFieldIndex({ multipleFieldIndex: index });
        this.setState({
            currentField: parentField,
            searchForm: {
                addRecordText: parentField?.searchForm?.addRecordText,
                url: parentField?.searchForm?.api?.url,
                resultMappings: parentField?.searchForm?.api?.resultMappings,
            },
            multipleSubFields: parentField.fields,
            searchFields: parentField.searchForm?.fields ?? [],
            multipleFieldLabel: parentField.label,
        });
    };

    handleSaveMultipleField = () => {
        const searchForm = {
            fields: this.state.searchFields,
            addRecordText: this.state.searchForm.addRecordText,
            api: {
                ...this.state.currentField.searchForm?.api,
                url: this.state.searchForm.url,
                resultMappings: this.state.searchForm.resultMappings,
            },
        };
        this.props.onMultipleEntriesChange(this.state.multipleSubFields, searchForm, this.props.multipleFieldIndex);
        this.handleLeaveMultipleField();
    };

    handleLeaveMultipleField = () => {
        this.props.onParentMappingChange('');
        this.props.updateFieldIndex({ multipleFieldIndex: -1 });
        this.setState({
            multipleSubFields: [],
            searchFields: [],
            selectedRepeatableTab: 'repeatableField',
            searchForm: {
                addRecordText: '',
                url: '',
                resultMappings: [
                    { field: '', title: '', mapping: '' },
                    { field: '', title: '', mapping: '' },
                ],
            },
        });
    };

    updateFields = (fields) => {
        if (this.isEditingNestedSearchFields()) {
            this.setState({ searchFields: fields });
        } else if (this.isEditingNestedFields()) {
            this.setState({ multipleSubFields: fields });
        } else {
            this.props.setEntries(fields);
        }
    };

    handleCancelSectionName = () => {
        this.setState({
            sectionName: this.props.form.sections[this.props.currentSection].name,
        });
        this.handleSectionNameDialogClose();
    };

    handleSectionNameDialogClose = () => {
        this.setState({
            sectionDialogOpen: false,
        });
    };

    handleSaveSectionName = (event) => {
        this.props.updateSectionName(this.state.sectionName);
        this.handleSectionNameDialogClose();
        event.preventDefault();
    };

    getValidFacts = () => {
        const sections = this.props.form.sections;
        let fields = [];
        if (this.isEditingNestedSearchFields()) {
            fields = this.state.searchFields.filter((searchField, index) => index !== this.props.currentFieldIndex);
        } else if (this.isEditingNestedFields()) {
            fields = this.state.multipleSubFields.filter((subField, index) => index !== this.props.currentFieldIndex);
        } else {
            fields = sections.flatMap((section, index) => {
                const entries = section.entries ?? [];
                if (index === this.props.currentSection) {
                    const filteredFields = entries.filter((entry, index) => index !== this.props.currentFieldIndex);
                    return filteredFields;
                } else {
                    return entries;
                }
            });
        }
        return fields.sort((a, b) => (a.field.toUpperCase() > b.field.toUpperCase() ? 1 : -1));
    };

    selectLinkedForm = () => {
        this.setState({ importFormDialogOpen: true });
    };

    linkForm = (formData) => {
        const payload = {
            action: 'import',
            data: formData,
        };
        this.props.onFormImport(payload);
    };

    hasNextSection = () => {
        const sections = this.props.form.sections;
        const notLast = this.props.currentSection < sections.length - 1;
        const hasEditableNext = sections.slice(this.props.currentSection + 1).some((section) => section.entries);
        return notLast && hasEditableNext;
    };

    hasPreviousSection = () => {
        const sections = this.props.form.sections;
        const notFirst = this.props.currentSection > 0;
        const hasPreviousEditableSction = sections
            .slice(0, this.props.currentSection)
            .some((section) => section.entries);
        return notFirst && hasPreviousEditableSction;
    };

    checkRenderConditions = (feature) => {
        const featureFlags = this.props.featureFlags;
        const checkFlags = featureFlags?.includes(feature.name) || !featureFlags?.filter(flag => flag !== 'Experimental').length;
        const checkExperimental = feature.experimental ? featureFlags?.includes('Experimental') : checkFlags;
        const checkRoles = !feature.roles?.length || this.props.userProfile?.roles?.some(role => feature.roles.includes(role));
        return checkExperimental && checkRoles;
    };

    handleToggleButtonGroup = (event, newView) => {
        if (newView !== null) {
            this.setState({ currentView: newView, jsonEditorError: false });
        }
        event.preventDefault();
    };

    render() {
        const adminArea = 'form';
        const sections = this.props.form ? this.props.form.sections : [];
        const currentSection = this.props.currentSection;
        const steps = sections.length > 0 ? sections.map((step) => (step.form ? step.form.name : step.name)) : [];
        const rightPanelOpen = this.state.rightPanelOpen;
        const leftPanelOpen = this.state.leftPanelOpen;
        const features = featuresList.formBuilder;
        const renderJsonEditor = this.checkRenderConditions(features.jsonEditor);
        const jsonEditorOpen = (this.state.currentView === 'json') && renderJsonEditor;
        const hasEditableSections = steps.length > 0 && sections.some((section) => !section.form);
        let entries = null;
        if (this.isEditingNestedSearchFields()) {
            entries = this.state.searchFields;
        } else if (this.isEditingNestedFields()) {
            entries = this.state.multipleSubFields;
        } else {
            entries = sections[currentSection] ? sections[currentSection].entries : [];
        }
        const stepper = (
            <StepperPanel
                currStep={this.props.currentSection}
                steps={steps}
                sections={sections}
                handleSectionsReorder={this.handleSectionsReorder}
                handleStepChange={this.handleStepChange}
                stepType={'Section'}
                handleAddSection={this.handleAddSection}
                handleDeleteSection={this.handleRemoveSection}
                isOpened={this.state.leftPanelOpen}
                importForm={this.selectLinkedForm}
            />
        );
        let stepperContents = null;
        const multipleFieldMenu = (
            <div className={this.props.classes.sidebarDiv}>
                <Typography className={this.props.classes.sectionTitle} variant="overline">
                    {this.state.sectionName}
                </Typography>
                <Typography className={this.props.classes.multipleFieldPath} variant="h5">
                    {this.state.currentField.field}
                </Typography>
                <ListItem
                    selected={this.state.selectedRepeatableTab === 'repeatableField'}
                    onClick={() => {
                        this.setState({
                            selectedRepeatableTab: 'repeatableField',
                        });
                    }}
                    classes={{
                        root: this.props.classes.listItem,
                        selected: this.props.classes.selectedTab,
                    }}
                >
                    <ListItemIcon className={this.props.classes.listItemIcon}>
                        <ListAlt color={'primary'} className={this.props.classes.iconColor} />
                    </ListItemIcon>
                    <ListItemText primary={'Repeatable Fields'} />
                </ListItem>
                <ListItem
                    button
                    className={this.props.classes.searchPropertiesTab}
                    onClick={() =>
                        this.setState({
                            isRepeatableTabExpanded: !this.state.isRepeatableTabExpanded,
                        })
                    }
                >
                    <ListItemIcon className={this.props.classes.listItemIcon}>
                        <SearchIcon className={this.props.classes.iconColor} />
                    </ListItemIcon>
                    <ListItemText primary={'Search Configuration'} />
                    {this.state.isRepeatableTabExpanded ? (
                        <ExpandMoreIcon className={this.props.classes.iconColor} />
                    ) : (
                        <KeyboardArrowRightIcon className={this.props.classes.iconColor} />
                    )}
                </ListItem>

                <Collapse
                    in={this.state.isRepeatableTabExpanded}
                    timeout="auto"
                    unmountOnExit
                    style={{
                        backgroundColor: '#005586',
                    }}
                >
                    <AccordionDetails className={this.props.classes.accordionDetails}>
                        <ListItem
                            selected={this.state.selectedRepeatableTab === 'searchFields'}
                            onClick={() => {
                                this.setState({
                                    selectedRepeatableTab: 'searchFields',
                                });
                            }}
                            classes={{
                                root: this.props.classes.listItemAccordion,
                                selected: this.props.classes.selectedTab,
                            }}
                        >
                            <ListItemText
                                classes={{ primary: this.props.classes.listItemTextAccordion }}
                                primary={'Search Fields'}
                            />
                        </ListItem>
                    </AccordionDetails>
                    <AccordionDetails className={this.props.classes.accordionDetails}>
                        <ListItem
                            selected={this.state.selectedRepeatableTab === 'searchProperties'}
                            onClick={() => {
                                this.handleOpenSearchPropertiesDialog();
                            }}
                            classes={{
                                root: this.props.classes.listItemAccordion,
                                selected: this.props.classes.selectedTab,
                            }}
                        >
                            <ListItemText
                                classes={{ primary: this.props.classes.listItemTextAccordion }}
                                primary={'Search Properties'}
                            />
                        </ListItem>
                    </AccordionDetails>
                </Collapse>
            </div>
        );
        if (this.isEditingNestedFields()) {
            if (leftPanelOpen) {
                stepperContents = multipleFieldMenu;
            }
        } else {
            stepperContents = stepper;
        }
        return (
            <div className={this.props.classes.root}>
                <UnsavedDialog
                    handleCloseUnsavedDialog={this.handleCloseUnsavedDialog}
                    openUnsavedDialog={this.state.openUnsavedDialog}
                    parent={adminArea}
                />
                <ActionBar
                    jsonEditorError={this.state.jsonEditorError}
                    parent={adminArea}
                    id={this.props.form.id}
                    name={this.props.form.name}
                    handleEditName={this.handleChangeForm}
                    newName={false}
                    isEditingMultipleField={this.isEditingNestedFields()}
                    handleSaveMultipleField={this.handleSaveMultipleField}
                    handleLeaveMultipleField={this.handleLeaveMultipleField}
                />
            {!jsonEditorOpen && (
                <ToggleButton
                    icon={leftPanelOpen ? <ChevronLeftIcon color="primary" /> : <ChevronRightIcon color="primary" />}
                    variant="contained"
                    aria-label={'Stepper Collapse Panel'}
                    onClick={this.handleLeftDrawerToggle}
                    className={clsx(this.props.classes.panelButton, {
                        [this.props.classes.leftCollapseButton]: leftPanelOpen,
                        [this.props.classes.leftExpandButton]: !leftPanelOpen,
                    })}
                ></ToggleButton>
            )}
            {!jsonEditorOpen && (
                <Drawer
                    anchor="left"
                    variant="permanent"
                    className={this.props.classes.drawer}
                    classes={{
                        paper: clsx({
                            [this.props.classes.drawerOpen]: leftPanelOpen,
                            [this.props.classes.drawerClose]: !leftPanelOpen,
                            [this.props.classes.multipleFieldLeftPanel]: this.isEditingNestedFields(),
                        }),
                    }}
                >
                    <div
                        className={clsx({
                            [this.props.classes.leftDrawerContainer]: leftPanelOpen,
                            [this.props.classes.leftDrawerContainerCollapsed]: !leftPanelOpen,
                        })}
                    >
                        <div className={this.props.classes.drawerSpacer} />
                        <div className={this.props.classes.drawerSpacer} />
                        {stepperContents}
                    </div>
                </Drawer>
            )}
                <DeleteDialog
                    handleDeleteFieldFromDialog={this.handleDeleteFieldFromDialog}
                    handleDeleteDialogClose={this.handleDeleteDialogClose}
                    open={this.state.deleteField.deleteDialogOpen}
                />
                <ImportFormDialog
                    open={this.state.importFormDialogOpen}
                    closeDialog={() => this.setState({ importFormDialogOpen: false })}
                    linkForm={this.linkForm}
                />
                {this.props.multipleFieldIndex < 0 && (
                    <Dialog open={this.state.sectionDialogOpen} onClose={this.handleSectionDialogClose} fullWidth>
                        <form onSubmit={this.handleSaveSectionName}>
                            <DialogTitle>{'Section Name'}</DialogTitle>
                            <DialogContent>
                                <TextField
                                    label={'Name'}
                                    value={this.state.sectionName}
                                    onChange={this.handleChangeSection}
                                    fullWidth
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleCancelSectionName}>Cancel</Button>
                                <Button type="submit">Save</Button>
                            </DialogActions>
                        </form>
                    </Dialog>
                )}
                <Grid container justifyContent="center" spacing={8} className={this.props.classes.grid}>
                    <Grid item xs={12} md={9} lg={10} xl={8}>
                        <div className={this.props.classes.contentSpacer} />
                        {renderJsonEditor && (
                            <Grid item xs={12} container justifyContent="flex-end" alignItems="center" className={this.props.classes.toggleButtonGroup}>
                                <Typography className={this.props.classes.view}>
                                    View
                                </Typography>
                                <ToggleButtonGroup
                                    size="small"
                                    value={this.state.currentView}
                                    exclusive
                                    onChange={this.handleToggleButtonGroup}
                                    aria-label="View Toggle"
                                >
                                    <Tooltip title="Form Builder" enterDelay={200} value="form">
                                        <ViewToggleButton aria-label="Form Builder View">
                                            <FormatListBulletedIcon />
                                        </ViewToggleButton>
                                    </Tooltip>
                                    <Tooltip title="JSON Editor" enterDelay={200} value="json">
                                        <ViewToggleButton aria-label="JSON Editor View">
                                            <CodeIcon />
                                        </ViewToggleButton>
                                    </Tooltip>
                                </ToggleButtonGroup>
                            </Grid>
                        )}
                        {!hasEditableSections && !jsonEditorOpen && (
                            <Panel key={'No Sections'}>
                                <div className={this.props.classes.sectionHeader}>
                                    <Typography variant="h6" inline={'true'}>
                                        Add a section to start building form
                                    </Typography>
                                </div>
                            </Panel>
                        )}
                        {hasEditableSections && !jsonEditorOpen && (
                            <Panel key={'Section'}>
                                <div className={this.props.classes.sectionHeader}>
                                    <Typography variant="h6">
                                        {this.props.multipleFieldIndex < 0
                                            ? this.state.sectionName
                                            : this.state.multipleFieldLabel}
                                    </Typography>
                                    {this.props.multipleFieldIndex < 0 && (
                                        <Tooltip title="Edit" enterDelay={200} disableFocusListener={true}>
                                            <IconButton aria-label="Edit" onClick={this.handleSectionDialogOpen}>
                                                <EditIcon color="action" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                    <div className={this.props.classes.grow} />
                                </div>
                                {entries && entries.length === 0 && (
                                    <div className={this.props.classes.text}>
                                        <Typography variant="body1" inline={'true'}>
                                            Add a field from the menu on the right
                                        </Typography>
                                        <ArrowForwardIcon color="action" className={this.props.classes.bigArrow} />
                                    </div>
                                )}
                                {entries?.length > 0 && (
                                    <DraggableFormDisplay
                                        fields={entries}
                                        handleSelectField={this.handleEntrySelected}
                                        handleDeleteField={this.handleDeleteDialog}
                                        handleEditRepeatableField={this.handleEditMultipleField}
                                        setFields={this.updateFields}
                                    />
                                )}
                                {this.props.multipleFieldIndex < 0 ? (
                                    <div className={this.props.classes.actionBar}>
                                        <div className={this.props.classes.grow}>
                                            {this.hasPreviousSection() && (
                                                <Button variant="contained" onClick={this.handleBack}>
                                                    <ChevronLeftIcon />
                                                    {'Previous'}
                                                </Button>
                                            )}
                                        </div>
                                        {this.hasNextSection() && (
                                            <Button variant="contained" onClick={this.handleContinue}>
                                                {'Next'}
                                                <ChevronRightIcon />
                                            </Button>
                                        )}
                                    </div>
                                ) : null}
                            </Panel>
                        )}
                        {jsonEditorOpen && (
                            <div>
                                {this.state.jsonEditorError && (
                                    <Alert severity={'error'}>
                                        <AlertTitle>JSON Parsing Error</AlertTitle>
                                        Invalid sections property in form
                                    </Alert>
                                )}
                                <DataEditor
                                    style={{ height: '70vh' }}
                                    data={this.props.form}
                                    handleUpdate={async (form) => {
                                        if (Array.isArray(form?.sections)) {
                                            this.setState({ jsonEditorError: false })
                                            await this.props.onSectionsChange('json', form);
                                            await this.props.onFormUpdated(form);
                                        } else {
                                            this.setState({ jsonEditorError: true })
                                        }
                                    }}
                                />
                            </div>
                        )}
                    </Grid>
                </Grid>

                <div>
                    {hasEditableSections && !jsonEditorOpen && (
                        <ToggleButton
                            icon={
                                rightPanelOpen ? (
                                    <ChevronRightIcon color="primary" />
                                ) : (
                                    <ChevronLeftIcon color="primary" />
                                )
                            }
                            variant="contained"
                            aria-label={'Collapse Panel'}
                            onClick={this.handleRightDrawerToggle}
                            className={clsx(this.props.classes.panelButton, {
                                [this.props.classes.rightCollapseButton]: rightPanelOpen,
                                [this.props.classes.rightExpandButton]: !rightPanelOpen,
                            })}
                        ></ToggleButton>
                    )}
                </div>
                <div>
                    {hasEditableSections && !jsonEditorOpen && (
                        <Drawer
                            anchor="right"
                            variant="permanent"
                            className={this.props.classes.drawer}
                            classes={{
                                paper: clsx({
                                    [this.props.classes.drawerOpen]: rightPanelOpen,
                                    [this.props.classes.drawerClose]: !rightPanelOpen,
                                }),
                            }}
                        >
                            <div className={this.props.classes.rightPanelSection}>
                                <div className={this.props.classes.drawerSpacer} />
                                <div className={this.props.classes.drawerSpacer} />
                                <FieldsPanel
                                    handleAddField={this.handleAddField}
                                    isOpen={this.state.rightPanelOpen}
                                    inMultipleMode={this.isEditingNestedFields()}
                                />
                                <FieldDialog
                                    handleChangeField={this.handleChangeField}
                                    factFields={this.getValidFacts()}
                                    open={this.state.openFieldDialog}
                                    field={
                                        this.isEditingNestedFields()
                                            ? this.state.currentMultipleField
                                            : this.state.currentField
                                    }
                                    form={this.props.form}
                                    handleCloseFieldDialog={this.handleCloseFieldDialog}
                                />
                                {this.state.openSearchPropertiesDialog && (
                                    <SearchPropertiesDialog
                                        open={this.state.openSearchPropertiesDialog}
                                        field={this.state.currentField}
                                        handleCancelSearchPropertiesDialog={this.handleCancelSearchPropertiesDialog}
                                        handleDoneSearchPropertiesDialog={this.handleDoneSearchPropertiesDialog}
                                        multipleSubFields={this.state.multipleSubFields}
                                        searchForm={this.state.searchForm}
                                    />
                                )}
                            </div>
                        </Drawer>
                    )}
                </div>
            </div>
        );
    }
}

export default compose(withAuthenticationContext, withStyles(styles))(FormBuilder);
